import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Chip } from '.';
export interface VipChipProps {
  /** Translate function */
  t: (key: string, options?: Record<string, string | number>) => string;
}
/* Renders a VipChip component */
export const VipChip: React.FC<React.PropsWithChildren<VipChipProps>> = ({ t }: VipChipProps) => {
  const theme = useTheme();
  const dotIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
      <circle cx="4.5" cy="4" r="3" fill={theme.palette.primary.main} />
    </svg>
  );
  return (
    <Chip
      startAdornment={{ mode: 'icon', icon: dotIcon }}
      label={t('ns.common:vip')}
      color="default"
      variant="outlined"
      size="small"
      sx={{
        fill: alpha(theme.palette.primary.main, 0.8),
      }}
    />
  );
};
